module.exports = "/lucky-balls/img/weager/Tab_pressed.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/Tab_pressed.png
// module id = 1174
// module chunks = 0